(() => {
  const selector = '.nailarts-masters-pilot';
  const suffix = /[\s\u00a0]*(?:inkl\.?\s*MwSt\.?\*?|incl\.?\s*VAT\.?\*?)/gi;

  function cleanPrice(section) {
    section.querySelectorAll('[bss-main-pdp] .bss-b2b-price-has-vat, [bss-main-pdp] .product-price_top .price').forEach((price) => {
      const walker = document.createTreeWalker(price, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) {
        const node = walker.currentNode;
        const updated = node.nodeValue.replace(suffix, '');
        if (updated !== node.nodeValue) node.nodeValue = updated;
      }
    });
  }

  function init() {
    document.querySelectorAll(selector).forEach((section) => {
      if (section.dataset.nailartsBssPriceReady) return;
      section.dataset.nailartsBssPriceReady = 'true';
      const observer = new MutationObserver(() => cleanPrice(section));
      observer.observe(section, { childList: true, subtree: true, characterData: true });
      cleanPrice(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

